import React from 'react'
// libs
import { useRouter } from 'hooks/useRouter'
import { useSelector } from 'react-redux'
// components
import ConditionButton from 'components/PageComponents/RiskTemplates/Edit/components/RiskTemplateFields/components/RiskTemplateField/components/ConditionButton'
// context
import { ImportedRiskContext } from 'components/Modals/ImportedRiskModal'
import { RiskTemplateAPIContext } from 'containers/Risks/RiskTemplate/Edit/layers/API'
// views
import { AsteriskIcon } from 'components/FormElements/components/InputLabel'
import { Option, OptionsWrapper, OptionWrapper, ResponseTypeWrapper } from './views'
// types
import { FieldType, IField } from 'types/graphql'
import { IOption } from 'components/FormElements/Select'
// store
import { responseTypesSelector } from 'store/reducers/riskTemplates'

export interface ResponsiveSelectProps {
  label: string
  field?: IField
  value?: IOption
  isError?: boolean
  required?: boolean
  onChange: (value: IOption) => void
  disabled?: boolean
}

const ResponseTypeSelect: React.FC<ResponsiveSelectProps> = ({ label, field, value, disabled, onChange, required }) => {
  const router = useRouter()

  const responseTypeSets = useSelector(responseTypesSelector)

  const [selected, setSelected] = React.useState(null)

  const { isImportedField } = React.useContext(ImportedRiskContext)
  const { riskTemplate, isRisk, isRiskTemplate, isRisksRegister } = React.useContext(RiskTemplateAPIContext)

  const showCondition = field.parentFieldId
    ? !riskTemplate.fields.find((f) => f.id === field.parentFieldId && f.fieldType === FieldType.Table)
    : true

  const options = (responseTypeSets.find((item) => item.id == field.responseTypeId)?.options || []).filter((option) => {
    if ((!isImportedField && isRisksRegister) || router.query.multiple) {
      return option.id === value?.value
    }
    return option
  })

  const onOptionClick = (option: any) => () => {
    if (selected === option.id) {
      setSelected(null)
      onChange?.(null)
      return
    }

    setSelected(option.id)
    onChange?.({ label: option.label, value: option.id })
  }

  React.useEffect(() => {
    if (!selected && value?.value) {
      setSelected(options.find((option) => option.id === value.value)?.id)
    }
  }, [value])

  return (
    <ResponseTypeWrapper>
      <span className='responseTypeLabel'>
        {(isRisk || isRiskTemplate) && required && <AsteriskIcon />}
        {!field.hideName && label}
      </span>
      <OptionsWrapper>
        {options.map((option) => (
          <OptionWrapper key={option.id}>
            <Option
              disabled={disabled}
              color={option.color}
              onClick={onOptionClick(option)}
              selected={option.id === selected}>
              {option.label}
            </Option>
            {isRiskTemplate && showCondition && (
              <ConditionButton value={option.id} fieldId={field.id} label={option.label} />
            )}
          </OptionWrapper>
        ))}
      </OptionsWrapper>
    </ResponseTypeWrapper>
  )
}

export default ResponseTypeSelect
